module.exports = __webpack_public_path__ + "img/menu-item-icon.016b6321.svg";